import script from "./PatientNotesBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientNotesBlock.vue?vue&type=script&setup=true&lang=js"

import "./PatientNotesBlock.vue?vue&type=style&index=0&id=7a8b681d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8b681d"]])

export default __exports__